import React from 'react';
import styled from 'styled-components';
import { SearchInput } from '../../../../../generic/ui/SearchInput';
import PlusIcon from '../../../../../generic/icons/IconLib/PlusIcon';

interface Props {
    input: string;
    setInput: (value: string) => void;
    onEnter: () => void;
    onAddPallet?: () => void;
    placeholder?: string;
    className?: string;
}

const TeudaScanBar: React.FC<Props> = ({
    input,
    setInput,
    onEnter,
    onAddPallet,
    placeholder = 'חיפוש משטח',
    className,
}) => {
    return (
        <Shell className={className}>
            {onAddPallet && (
                <AddBtn type='button' onClick={onAddPallet} aria-label='add pallet'>
                    <PlusIcon />
                </AddBtn>
            )}
            <SearchWrap>
                <SearchInput
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') onEnter();
                    }}
                    placeholder={placeholder}
                />
            </SearchWrap>
        </Shell>
    );
};

export default TeudaScanBar;

const Shell = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    direction: rtl;
`;

const SearchWrap = styled.div`
    flex: 1;
    min-width: 0;
`;

const AddBtn = styled.button`
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.875rem;
    height: 2.875rem;
    padding: 0;
    border-radius: 0.875rem;
    background: ${({ theme }) => theme.colors.accent};
    color: ${({ theme }) => theme.colors.ink};
    border: 1px solid ${({ theme }) => theme.colors.accent};
    cursor: pointer;
    transition: all ${({ theme }) => theme.motion.fast} ease;

    svg {
        width: 1rem; height: 1rem;
    }

    &:hover {
        background: ${({ theme }) => theme.colors.accentDeep};
        border-color: ${({ theme }) => theme.colors.accentDeep};
    }

    &:active {
        transform: translateY(1px);
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 2.5rem;
        height: 2.5rem;
    }
`;
